<template>
  <app-content class="app-home-vue frame-page">
    <template v-if="currentAccountSets&&User.role!='Admin'">
      <Row :space="24">
        <Cell width="6">
          <div  @click="goTab({title: '科目余额表',key: 'SubjectBalance'})" style="height: 140px;border-radius:15px;"
                class="block block-subject-balance flex-1 rounded-6px flex flex-column items-center justify-center text-hover bg-white-color">
            <img src="../assets/AccountBalances.png" class="icon-img">
            <span class="mt-20px text-16px" style="text-align: center;padding-top: 10px">科目余额表</span>
          </div>
        </Cell>
        <Cell width="6">
          <div  @click="goTab({title: '资产负债表',key: 'zcfzb'})" style="height: 140px;border-radius:15px;"
                class="block block-zcfz flex-1 rounded-6px flex flex-column items-center justify-center text-hover bg-white-color">
            <img src="../assets/BalanceSheet.png" class="icon-img">
            <span class="mt-20px text-16px" style="text-align: center;padding-top: 10px">资产负债表</span>
          </div>
        </Cell>
        <Cell width="6">
          <div  @click="goTab({title: '利润表',key: 'lrb'})" style="height: 140px;border-radius:15px;"
                class="block block-lr flex-1 rounded-6px flex flex-column items-center justify-center text-hover bg-white-color">
            <img src="../assets/profit.png" class="icon-img">
            <span class="mt-20px text-16px" style="text-align: center;padding-top: 10px">利润表</span>
          </div>
        </Cell>
        <Cell width="6">
          <div  @click="goTab({title: '现金流量表',key: 'xjllb'})" style="height: 140px;border-radius:15px;"
                class="block block-xjll flex-1 rounded-6px flex-column flex items-center justify-center text-hover bg-white-color">
            <img src="../assets/CashFlow.png" class="icon-img">
            <span class="mt-20px text-16px" style="text-align: center;padding-top: 10px">现金流量表</span>
          </div>
        </Cell>
      </Row>
      <Row :space="24">
        <Cell width="8">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <div class="h-panel-title">{{ currentAccountSets.currentAccountDate|fqFormat }}</div>
              <div class="h-panel-right"><span class="gray-color">当期有</span><i class="h-split"></i><span class="font20 primary-color">{{ voucherCount }}</span><i class="h-split"></i><span class="gray-color">张凭证</span></div>
            </div>
            <div class="text-hover h-panel-body progress-div home-part-body" align="center" @click="addVouch">
              <img src="../assets/voucherAdd.png" style="width: 100px;height: 100px"/>
              <p>新增凭证</p>
            </div>
          </div>
        </Cell>
        <Cell width="8">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <div class="h-panel-title">货币资金</div>
              <div class="h-panel-right"><span class="gray-color">总资金</span><i class="h-split"></i><span v-tooltip :content="cashTotal" class="font20 primary-color text-hover">{{ cashTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div class="h-panel-body">
              <Row style="line-height: 45px;" type="flex" v-for="cash in cashData" :key="cash.name">
                <Cell :flex="1">{{ cash.name }}</Cell>
                <Cell><b class="text-hover" v-tooltip :content="cash.value">{{ cash.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="8">
          <div class="h-panel" style="height: 235px">
            <div class="h-panel-bar">
              <div class="h-panel-title">收付款项</div>
            </div>
            <div class="h-panel-body">
              <Row style="line-height: 45px;" type="flex" v-for="cope in copeData" :key="cope.name">
                <Cell :flex="1">{{ cope.name }}</Cell>
                <Cell><b class="text-hover" v-tooltip :content="cope.value">{{ cope.value|moneyFormat }}</b>元</Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="16">
          <div class="h-panel">
            <div class="h-panel-body home-part-body2">
              <Row :space="20">
                <Cell :width="24">
                  <Chart  style="height: 290px" :options="businessTrendsOptions"></Chart>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <Cell width="8">
          <div class="h-panel h-280px px-14px">
            <div class="h-panel-bar">
              <div class="h-panel-title">费用统计</div>
              <div class="h-panel-right"><span class="gray-color">总费用</span><i class="h-split"></i><span v-tooltip :content="costTotal" class="font20 primary-color text-hover">{{ costTotal|moneyFormat }}</span><i class="h-split"></i><span class="gray-color">元</span></div>
            </div>
            <div>
              <Chart ref="fygc" style="height: 280px" :options="fygc"></Chart>
            </div>
          </div>
        </Cell>
      </Row>
    </template>
    <div class="h-panel" v-if="!currentAccountSets&&User.role!='Admin'">
      <div class="h-panel-bar"><span class="h-panel-title">初始化账套</span></div>
      <div class="h-panel-body">
        <Form ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
          <FormItem label="单位名称:" prop="companyName">
            <input type="text" v-model="form.companyName">
          </FormItem>
          <FormItem label="账套启用年月:" prop="enableDate">
            <DatePicker type="month" v-model="form.enableDate"/>
          </FormItem>
          <FormItem label="统一社会信用代码:">
            <input type="text" v-model="form.creditCode">
          </FormItem>
          <FormItem label="会计准则:" prop="accountingStandards">
            <Radio v-model="form.accountingStandards" dict="accountingStandards"></Radio>
          </FormItem>
          <FormItem label="单位所在地:">
            <CategoryPicker ref="CategoryPicker" :option="pickerOption" type="key" showAllLevels v-model="form.address"></CategoryPicker>
          </FormItem>
          <FormItem label="行业:">
            <Select v-model="form.industry" dict="industry"></Select>
          </FormItem>
          <FormItem label="增值税种类:" prop="vatType">
            <Radio v-model="form.vatType" dict="vatRadios"></Radio>
          </FormItem>
          <FormItem label="凭证是否需要审核:" prop="voucherReviewed">
            <Radio v-model="form.voucherReviewed" dict="needRadios"></Radio>
          </FormItem>
          <FormItem single>
            <Button color="green" @click="submit" :loading="loading">创建账套</Button>
          </FormItem>
        </Form>
      </div>
    </div>
  </app-content>
</template>
<script>
import revenueProfit from '../js/data/revenueProfit';
import {getTotalData} from '../js/locations/district';
import { mapMutations, mapState } from 'vuex'
import moment from "moment";
import fygc from '../js/data/fygc';
import businessTrends from "../js/data/businessTrends";

// 常量提取，统一管理表单默认值
const EMPTY_FORM = {
  "accountingStandards": "0",
  "address": null,
  "companyName": "",
  "creditCode": "",
  "enableDate": null,
  "fixedAssetModule": "0",
  "cashierModule": "0",
  "voucherReviewed": "0",
  "industry": "",
  "vatType": "0"
};

// 公共数值计算函数，复用减少重复代码
function calcSum(list) {
  var total = 0;
  list.forEach(function(item) {
    total = total + Number(item.value || 0);
  });
  return total.toFixed(2);
}

export default {
  name: 'Home',
  data: function() {
    return {
      businessTrendsOptions: businessTrends,
      fygc: fygc,
      revenueProfitOptions: revenueProfit,
      cashData: [{name: '库存现金', value: 0}, {name: '银行存款', value: 0}, {name: '其他货币资金', value: 0}],
      costData: [{name: '销售费用', value: 0}, {name: '管理费用', value: 0}, {name: '财务费用', value: 0}],
      copeData: [{name: '应收账款', value: 0}, {name: '应付账款', value: 0}],
      voucherCount: 0,
      loading: false,
      datas: [],
      type: 'type1',
      initLock: false, // 防止重复请求接口
      pickerOption: {
        keyName: 'id',
        titleName: 'title',
        dataMode: 'list',
        parentName: 'parentId',
        datas: getTotalData()
      },
      form: Object.assign({}, EMPTY_FORM),
      validationRules: {
        required: ["companyName", "enableDate", "accountingStandards", "fixed_asset_module", "cashier_module", "voucherReviewed", "vatType"]
      }
    };
  },
  computed: {
    ...mapState(['currentAccountSets','User']),
    copeTotal: function() {
      return calcSum(this.copeData);
    },
    costTotal: function() {
      return calcSum(this.costData);
    },
    cashTotal: function() {
      return calcSum(this.cashData);
    }
  },
  watch: {
    currentAccountSets: function(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    ...mapMutations(['newTab']),
    openMore: function() {
      this.$router.push({name: 'Chart'});
    },
    addVouch: function() {
      this.$router.push({name: 'VoucherForm'});
    },
    submit: function() {
      var self = this;
      var validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.loading = true;
      this.form.enableDate = moment(this.form.enableDate).format("YYYY-MM-DD");
      var apiMethod = this.form.id ? 'update' : 'save';
      this.$api.setting.accountSets[apiMethod](this.form).then(function() {
        self.loading = false;
        window.location.reload();
      }).catch(function(err) {
        self.loading = false;
        self.$message.error('保存失败：' + (err.message || '接口异常'));
      });
    },
    init: function() {
      var self = this;
      // 重复请求拦截
      if (this.initLock || !this.currentAccountSets) {
        return;
      }
      this.initLock = true;
      Promise.all([
        Api.home.voucherCount(),
        Api.home.chart.revenueProfit(),
        Api.home.chart.cost(),
        Api.home.chart.cash(),
        Api.home.chart.cope(),
        Api.home.chart.businessTrends()
      ]).then(function(reslut) {
        self.voucherCount = reslut[0].data || 0;
        self.cashData = reslut[3].data || [];
        self.costData = reslut[2].data || [];
        self.copeData = reslut[4].data || [];
        self.updateRevenueProfitOptions(reslut[1].data);
        self.updateBusinessTrendsOptions(reslut[5].data);
        // 更新费用饼图
        fygc.series[0].data = self.costData;
        fygc.graphic.style.text = "费用构成\n" + self.costTotal;
        if (self.$refs.fygc) {
          self.$refs.fygc.update(fygc);
        }
      }).catch(function(err) {
        self.$message.error('首页数据加载异常：' + (err.message || '网络错误'));
      }).finally(function() {
        self.initLock = false;
      });
    },
    updateBusinessTrendsOptions: function(chartData) {
      chartData = chartData || {};
      var revenue = chartData["收入"];
      var costing = chartData["成本"];
      var cost = chartData["费用"];
      var profit = chartData["利润"];
      var opt = Object.assign({}, this.businessTrendsOptions);
      if (revenue) {
        Object.keys(revenue).forEach(function(value) {
          opt.series[0].data[Number(value) - 1] = Number(revenue[value] || 0).toFixed(2);
        });
      }
      if (costing) {
        Object.keys(costing).forEach(function(value) {
          opt.series[1].data[Number(value) - 1] = Number(costing[value] || 0).toFixed(2);
        });
      }
      if (cost) {
        Object.keys(cost).forEach(function(value) {
          opt.series[2].data[Number(value) - 1] = Number(cost[value] || 0).toFixed(2);
        });
      }
      if (profit) {
        Object.keys(profit).forEach(function(value) {
          opt.series[4].data[Number(value) - 1] = Number(profit[value] || 0).toFixed(2);
        });
      }
      this.businessTrendsOptions = opt;
    },
    updateRevenueProfitOptions: function(chartData) {
      chartData = chartData || {};
      var lr = chartData["本年利润"];
      var zysr = chartData["主营业务收入"];
      var opt = Object.assign({}, this.revenueProfitOptions);
      if (lr) {
        Object.keys(lr).forEach(function (value) {
          var num = Number(lr[value] || 0) / 1000;
          opt.series[1].data[Number(value) - 1] = num.toFixed(2);
        });
      }
      if (zysr) {
        Object.keys(zysr).forEach(function (value) {
          var num = Number(zysr[value] || 0) / 1000;
          opt.series[0].data[Number(value) - 1] = num.toFixed(2);
        });
      }
      this.revenueProfitOptions = opt;
    },
    onAccountSuccess: function () {
      window.location.replace("/");
    },
    goTab: function (tab) {
      var self = this;
      if (tab.key === 'SubjectBalance') {
        this.$router.push({name: 'SubjectBalance'});
        return;
      }
      this.$api.report.template.list().then(function (res) {
        var arr = res.data || [];
        var map = new Map();
        arr.forEach(function (object) {
          map.set(object.templateKey, object);
        });
        var targetObj = map.get(tab.key);
        if (!targetObj) {
          self.$message.warning('未找到对应报表模板');
          return;
        }
        var name = 'ReportView' + targetObj.type;
        var id = targetObj.id;
        self.$router.push({name: name, params: {reportId: id}});
      }).catch(function (err) {
        self.$message.error('报表加载失败：' + (err.message || '接口异常'));
      });
    }
  },
  mounted: function () {
    this.init();
  }
};
</script>
<style scoped lang="less">
// 移除无用废弃.box2样式，精简代码
.icon-img {
  padding-top: 20px;
  width: 20%;
  height: 70%;
  margin: 0 auto;
  text-align: center;
  display: block; // 消除图片底部空白缝隙，优化显示
}

.h-panel-bar {
  padding: 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.block {
  overflow: hidden;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 6px;
    width: 100%;
  }

  // 分类底部色块，层级清晰，无JS插值，零编译报错
  &-subject-balance:after {
    background: #3F8DFF;
  }

  &-zcfz:after {
    background: #B69CE7;
  }

  &-lr:after {
    background: #FFC600;
  }

  &-xjll:after {
    background: #3CBDD5;
  }
}
</style>